module.exports = __webpack_public_path__ + "img/about7.38dca5ec.png";